/**
 * BLOCK - SEARCH - LISTENERS
 */

setupEventListenersForSearch();

// Creates the event listeners
function setupEventListenersForSearch() {
  // When the search term is changed
  document.querySelectorAll('.search__input').forEach((element) => {
    element.addEventListener('input', showResetButton);
  });
  
  // On clicking on the search cross icon
  document.querySelectorAll('.search__form button[type="reset"]').forEach((element) => {
    element.addEventListener('click', resetSearch);
  });
  
  // On leaving the search input
  document.querySelectorAll('.search__input').forEach((element) => {
    element.addEventListener('focusout', closeSearch);
  });
}

/**
 * BLOCK - SEARCH - GENERAL
 */

// Show the reset search button
function showResetButton() {
  var target = event.target,
      form = target.closest('form'),
      resetButton = form.querySelector('button[type="reset"]'),
      inputValue = target.value;

  inputValue != '' ? resetButton.classList.remove('hidden') : resetButton.classList.add('hidden');
}

// Resets the search input
function resetSearch() {
  document.querySelectorAll('.search__form').forEach((element) => {
    element.querySelector('input[type="search"]').value = '';
  });

  document.querySelectorAll('.search__form button[type="reset"]').forEach((element) => {
    element.classList.add('hidden');
  });
}

// Closes the search wrapper if in the header icons
function closeSearch() {
  var container = event.target.closest('.header__item-search');

  if (container !== null) {
    container.classList.remove('header__item-search--expanded', 'header__item-search--active');
    container.closest('.header__wrapper').classList.remove('header__wrapper--search');
  }
}